<template>
    <main>
        <div class="title">
            <el-image class="title-img" :src="require('../../assets/images/pc_hz_title_line1.png')" fit="cover" :lazy="true"></el-image>
            <h2 class="title-text">{{ title }}</h2>
            <el-image class="title-img" :src="require('../../assets/images/pc_hz_title_line2.png')" fit="cover" :lazy="true"></el-image>
        </div>
    </main>
</template>

<script>
export default {
    props:{
        title:{
            type:String,
            default:""
        }
    }
}
</script>

<style lang="less" scoped>
    .title{
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        margin-bottom: 3%;
        .title-text{
            //font-size:1.4vw;
            margin:0 10px;
            @media (max-width: 1024px) {
                font-size:2.2vw;
            }
            @media (max-width: 768px) {
                font-size:3vw;
            }
            @media (max-width: 594px) {
                font-size:18px;
            }
        }
        .title-img{
            display: flex;
            align-items: center;
            width:20%;
            @media (max-width: 594px) {
                width:10%;
            }
            @media (max-width: 480px) {
                display:none;
            }
        }
    }
</style>
